import { injectCpmsBoChargePointOcppApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-charge-point-ocpp.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoChargePointOcppApi = injectCpmsBoChargePointOcppApi(baseApi);

export const {
  useCpmsBoChargePointResetOcppMutation,
  useCpmsBoGetChargePointOcppConfigurationQuery,
  useCpmsBoGetDiagnosticsOcppMutation,
  useCpmsBoTriggerMessageOcppMutation,
  useCpmsBoUnlockConnectorOcppMutation,
  useCpmsBoUpdateChargePointOcppConfigurationMutation,
  useCpmsBoStartTransactionOcppMutation,
  useCpmsBoStopTransactionOcppMutation,
} = cpmsBoChargePointOcppApi;
